<template>
    <Textarea v-model="text" :rows="rows" :cols="cols" :autoResize="autoResize" :disabled="readonly" :placeholder="readonly? '' : placeholder" />
</template>

<script>
import { computed } from 'vue'
import Textarea from 'primevue/textarea';

export default {
    name: 'tw-textarea',
    components: {
        Textarea
    },
    setup(props, context) {
        const text = computed({
            get() {
                return (props.modelValue === null || props.modelValue === undefined) ? '' : props.modelValue
            },
            set(value){
                context.emit('update:modelValue', value)
            }
        })

        return {
            text
        }
    },
    props: {
        modelValue: null,
        autoResize: Boolean,
        rows: {
            type: Number,
            default: 5
        },
        cols: null,
        readonly: Boolean,
        placeholder: {
            type: String,
            default: '请输入内容'
        }
    }
}
</script>
